import { render, staticRenderFns } from "./resultquizkomunikasi.vue?vue&type=template&id=1c525114&"
import script from "./resultquizkomunikasi.vue?vue&type=script&lang=js&"
export * from "./resultquizkomunikasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports